import { FunctionalComponent, Fragment, h } from 'preact';

import { Header } from './header';

export const FallbackLayout: FunctionalComponent = ({ children }) => {
	return (
		<Fragment>
			<Header/>
			{children}
		</Fragment>
	);
};
